export const MS_PER_DAY = 1000 * 60 * 60 * 24;

/**
 * Mapping of recent period identifiers to their corresponding number of days.
 * This is the single source of truth for recent period configuration.
 */
export const RECENT_PERIOD_MAPPINGS = [
  { recentPeriod: "LAST_7", noOfDays: 7 },
  { recentPeriod: "LAST_14", noOfDays: 14 },
  { recentPeriod: "LAST_21", noOfDays: 21 },
  { recentPeriod: "LAST_30", noOfDays: 30 },
] as const;

/**
 * Array of recent period identifiers, derived from RECENT_PERIOD_MAPPINGS.
 * This ensures the two stay in sync automatically.
 */
export const RECENT_PERIODS = RECENT_PERIOD_MAPPINGS.map((m) => m.recentPeriod);
